import { atom, useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { toggleArrayValue } from '@/module/public/util/toggleArrayValue';

export interface PublicMetaState {
  publishers: string[];
  isOfficialQuiz: boolean;
  mapTemplate: string;
  questionSize: string;
}

export const initialPublicMetaState: PublicMetaState = {
  publishers: [],
  isOfficialQuiz: false,
  mapTemplate: '',
  questionSize: '',
};

export const publicMetaAtom = atomWithStorage<PublicMetaState>(
  'publicMetaState',
  initialPublicMetaState,
);

export const autoApplyAtom = atom<boolean>(true);

export const usePublicMetaFilter = () => {
  const [state, setState] = useAtom(publicMetaAtom);

  const [autoApply, setAutoApply] = useAtom(autoApplyAtom);

  const handleSelectedPublishers = (publisherId: string) => {
    setState(prev => ({
      ...prev,
      publishers: toggleArrayValue(prev.publishers, publisherId),
    }));
  };

  const resetPublisher = () => {
    setState(prev => ({
      ...prev,
      publishers: [],
    }));
  };

  const handleToggleIsOfficialQuiz = (checked: boolean) => {
    setState(prev => ({
      ...prev,
      isOfficialQuiz: checked,
    }));
  };

  const handleSelectedMapTemplateType = (templateType: string) => {
    setState(prev => ({
      ...prev,
      mapTemplate: templateType,
    }));
  };

  const handleSelectedQuestionSize = (questionSize: string) => {
    setState(prev => ({
      ...prev,
      questionSize,
    }));
  };
  const handleAutoApply = (checked: boolean) => {
    setAutoApply(checked);
  };

  const handleMetaFilter = (meta: PublicMetaState) => {
    setState({
      ...state,
      questionSize: meta.questionSize,
      isOfficialQuiz: meta.isOfficialQuiz,
      mapTemplate: meta.mapTemplate,
      publishers: meta.publishers,
    });
  };

  const removeAll = () => {
    setState(initialPublicMetaState);
  };

  return {
    selectedPublishers: state.publishers,
    checkedOfficialQuiz: state.isOfficialQuiz,
    selectedMapTemplate: state.mapTemplate,
    selectedQuestionSize: state.questionSize,
    state,
    autoApply,
    handleAutoApply,
    handleSelectedPublishers,
    resetPublisher,
    handleToggleIsPublicQuiz: handleToggleIsOfficialQuiz,
    handleSelectedMapTemplateType,
    handleSelectedQuestionSize,
    handleMetaFilter,
    removeAll,
  };
};
